import React, { useEffect } from 'react';
import ContactUs from '../components/Contactus/ContactUs'
import ContactForm from '../components/Contactus/ContactForm'

export default function ContactUsPage() {
     useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  return (
    <>
      <ContactUs/>
      <ContactForm/>
    </>
  )
}
